module.exports = __webpack_public_path__ + "0e03e2dfb4bf496984af3438f63432bf.xls";